<template>
  <BaseCard
   :footer-visible="false"
   :caption-visible="false"
 >
   <template #title>
     <span class="h3 font-weight-bold mb-0 text-uppercase">
        Logs de migración
     </span>
   </template>
   <LogImportsTable :logs="logs" />
 </BaseCard>
</template>


<script>
import LogImportsTable from '@/components/log-imports/table/LogImportsTable.vue'
import BaseCard from '@/components/ui/card/BaseCard.vue'

export default {
  components: { BaseCard, LogImportsTable },
  data() {
    return {
      logs: [],
    }
  },
}
</script>
